<template>
  <div class="hero-video-placeholder">
    <content-loader
      class="d-none d-lg-block"
      primary-color="#DEB1FD"
      secondary-color="#cccccc"
      :primary-opacity="0.6"
      :secondary-opacity="0.5"
      width="882"
      height="514"
      viewBox="0 0 882 514"
    >
      <rect x="0" y="0" width="882" height="514" />
    </content-loader>
    <content-loader
      class="d-lg-none"
      primary-color="#DEB1FD"
      secondary-color="#cccccc"
      :primary-opacity="0.6"
      :secondary-opacity="0.5"
      :width="width"
      :height="totalHeight"
    >
      <rect x="0" y="0" :width="width" :height="videoHeight" />
      <rect x="0" :y="videoHeight + gap" :width="width" :height="labelHeight" />
    </content-loader>
  </div>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
  name: "hero-video-placeholder",
  components: { ContentLoader },
  data() {
    return {
      width: window.innerWidth,
      gap: 2,
      labelHeight: 66,
    };
  },
  computed: {
    videoHeight() {
      return this.width / (16 / 9);
    },
    totalHeight() {
      return this.videoHeight + this.gap + this.labelHeight;
    },
  },
  methods: {
    onResize() {
      this.width = window.innerWidth;
    },
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
  },
  mounted() {
    window.addEventListener("resize", this.onResize);
  },
};
</script>
